<template>
    <div class="image__location--box " >
    <div v-if="loading" class="loading__box">
      <div class="loading show">
        <div class="spin"></div>
      </div>
    </div>
      <div v-else>
        <div class="image__container"  v-for="(image, imageIndex) in  imgItems" :key="imageIndex" @click="open()">
          <div class="icon__glass-container"  >
            <font-awesome-icon class="icon__glass" :icon="iconGlass" />
          </div>
          <img  class="image__location" :src="image.src" :alt="image.title">
          
        </div>
      </div>
      <div>
        <LightBox :items="imgItems" nameLightbox="lightboxIndividual" :openLightBox="model" @closeLightBox="close" />
      
      </div>
      <!-- <CoolLightBox
          :items="items"
          :index="index"
          :useZoomBar="true"
          @close="index = null">
      </CoolLightBox> -->
    
    </div>
    </template>
    
    <script>
    import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
    import {mapActions, mapGetters} from "vuex"
    import LightBox from "../../core/lightbox/LightBox.vue"
    export default {
      name: "ImageIndividual",
      props: ["typeImage", "urlImg"],
      components:{
       LightBox
      },
      data() {
        return{
          planta: true,
          plantaF: false,
          plantaUrl: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/casas/modelos/ENCINO.jpeg",
          iconGlass: faMagnifyingGlass,
          baseUrl: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/',
          id: '',
          items: [],
          modelos : [],
          index: null,
          model:false,
          typeUrl:''
        }
      },
      computed: {
        ...mapGetters({
          selected : 'getStatusA',
          urlImage: 'getUrlImageLocation',
          loading: 'getStatusLoading'
        }),
        development(){
          return { id: this.id }
        },
        formatImage(){
          let formato;
          if(this.urlImg === 'bosques/casas/modelos'){
            formato = '.png'
          }else{
            formato = '.jpeg'
          }
          return formato;
        },
        arr(){
          return this.items
        },
        typeModel(){
          let src;
          if(this.typeImage === "modeloCasas"){
            src = `https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/${this.urlImg}/${this.selected.type}${this.formatImage}`
            //this.typeUrl = src;
          }else if(this.typeImage === "modeloDeptos"){
            src = `https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/${this.urlImg}/${this.selected.imagePrototype}`
            //this.typeUrl = src;
          }else if(this.typeImage === 'modeloDeptosTP'){
            src = `${this.urlImg}/${this.selected.imagePrototype}`
            //this.typeUrl = src;
          }
          return src
        },
        imgItems(){
          let arr =[];
            if(this.typeImage === "terreno"){
              arr.push({
                title: this.selected.name,
                src: this.urlImage
              });
              
            }else{
              arr.push({
                title: this.selected.name,
                src :this.typeModel
              });
            }
          return arr
        }
    
      },
      methods: {
          ...mapActions(["getAvailableImageLocation"]),
          open(){
            this.model= true
          },
          close(){
            this.model=false
          }
      },
      mounted() {
    
      },
      beforeDestroy(){
    
      }
    }
    </script>
    
    <style>
    :root {
      --animate-duration: 250ms;
      --animate-delay: 0.9s;
    }
    .quick {
      transition-duration: "0ms" !important;
    }
    </style>